import { ChangeDetectorRef, Component } from '@angular/core';
import { ExpansionService } from '../../expansion.service';
import { ExpanderComponent } from '../expander/expander.component';
import { ExpansionSectionHeaderComponent } from '../expansion-section-header/expansion-section-header.component';

@Component({
	selector: 'ws-expander-section',
	templateUrl: '../expander/expander.component.html',
})
export class ExpanderSectionComponent<
	COMPONENT_INTERFACE extends Record<string, any> = Record<string, any>
> extends ExpanderComponent<COMPONENT_INTERFACE> {
	constructor(expansionService: ExpansionService, cdr: ChangeDetectorRef) {
		super(expansionService, cdr);
	}

	public get refs() {
		return this.cluster?.instances.filter((i) => !i?.ref?.instance?.['hideSection']?.());
	}

	protected initCluster() {
		if (!this.clusterInitialized) {
			this.cluster.pushInstances(
				this.expansionService.applyExpansions(
					this.scope,
					this.container,
					this.styleClass,
					ExpansionSectionHeaderComponent
				)
			);

			this.cluster.assign(this.contextName, this.context);

			this.clusterInitialized = true;

			this.cdr.detectChanges();
		}
	}
}
